// src/components/layout/Layout.jsx - Final
import { useAuth } from "../../contexts/AuthContext";
import React from 'react';
import { Link, useLocation, useNavigate, Outlet } from 'react-router-dom';
import './Layout.css';

const Layout = () => { // No children prop
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();
  <button onClick={logout}>Logout</button>

  const handleLogout = () => {
  logout();
  navigate("/login");
};


  const menuItems = [
  { path: '/dashboard', icon: '📊', label: 'Dashboard' },

  ...(currentUser?.role === "admin"
    ? [
        { path: '/companies', icon: '🏢', label: 'Companies' },
        { path: '/jobs', icon: '💼', label: 'Jobs' }
      ]
    : []),

  { path: '/candidates', icon: '👤', label: 'Candidates' }
];

  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2 className="logo">JSK CRM</h2>
          <p className="logo-subtitle">Placement Management</p>
        </div>
        
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>
        
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">
              {currentUser?.name?.charAt(0) || 'U'}
            </div>
            <div className="user-details">
              <h4>{currentUser?.name || 'User'}</h4>
              <p>{currentUser?.role === 'admin' ? 'Administrator' : 'Recruiter'}</p>
            </div>
          </div>
          <button onClick={handleLogout} className="logout-btn">
            <span>🚪</span> Logout
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        <header className="main-header">
          <h1 className="page-title">
            {menuItems.find(item => item.path === location.pathname)?.label || 'Dashboard'}
          </h1>
          <div className="header-actions">
            <div className="date-display">
              {new Date().toLocaleDateString('en-US', { 
                weekday: 'long', 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </div>
          </div>
        </header>
        
        <div className="content-container">
          {/* This Outlet will render Dashboard, Companies, etc. */}
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;